export const BelgianEnterpriseNumber = /0[0-9]{9}/
export const Email =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const LettersNumbersSlashesAndDashes = /^[a-zA-Z0-9/-]*$/
export const PostalCode = /[0-9]*/
